// Basque ('eu') is itself a valid BCP-47 locale tag; Spanish maps to 'es-ES'.
// Kept as a plain string param (not the per-module `Lang` type) so this file
// has no dependency on any feature module's i18n.
export function localeFor(lang: string): string {
  return lang === 'es' ? 'es-ES' : 'eu'
}

function toDate(value: string | Date): Date {
  return typeof value === 'string' ? new Date(value) : value
}

/** Date-only, e.g. "11/10/2026". `value` may be a `YYYY-MM-DD` string, an ISO timestamp, or a Date. */
export function formatDate(value: string | Date, locale: string): string {
  const date = toDate(value)
  if (Number.isNaN(date.getTime())) return ''
  return new Intl.DateTimeFormat(locale, { day: '2-digit', month: '2-digit', year: 'numeric' }).format(date)
}

/** Date + time, e.g. "11/10/2026, 18:30" — for timestamps like "última actualización". */
export function formatDateTime(value: string | Date, locale: string): string {
  const date = toDate(value)
  if (Number.isNaN(date.getTime())) return ''
  return new Intl.DateTimeFormat(locale, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(date)
}
